import logo from "../../assets/icons/Logo.svg";
import { StyledFormHeader } from "./styled";

const LoginHeader = () =>{

    return(
        <StyledFormHeader>
            <img src={logo} alt="Kenzie Hub" />
        </StyledFormHeader>
    )

}

export default LoginHeader